// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"); */

.navbar_TZGTY {
  background: var(--ffffffdb-background); 
  backdrop-filter: blur(10px); 
  color: var(--black-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
  position: fixed; 
  height: 50px;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000; 

  .logo_NHVZT {
    cursor: pointer;
    height: 30px;
  }
  .name_IKJJ5{
    display: flex;
    align-items: center;
    font-size: 25px;
    text-transform: capitalize;
    font-weight: 400;
    font-family: "Inter", sans-serif;
    img{
      margin-right: 10px;
    }
    span{
      font-family: "Inter", sans-serif;
      text-transform: uppercase;
    }
  }
}

.hamburger_cR5kJ {
  background: none;
  border: none;
  cursor: pointer;
  display: none; 
}

.hamburger_cR5kJ img {
  width: 25px;
  height: 25px;
}

.navLinks_ybPDI {
  list-style: none;
  display: flex;
  gap: 20px;
  margin: 0;
  padding: 0;
  align-items: center;
  height: 100%;
}
.btnContainerNavbar_GSJLB {
  display: flex;
  align-items: center;
  gap: 15px;
}



.navLinks_ybPDI li {
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  transition: color 0.3s ease;
}

.navLinks_ybPDI li:hover {
  color: var(--ec-color);
}

.buttonContainer_ta06y {
  display: flex;
  align-items: center;
  gap: 10px;
}

.button_ZikiB {
  background-color: var(--_10a37f-background);
  color: var(--white-color);
  width: 120px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 7px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  -ms-border-radius: 7px;
  -o-border-radius: 7px;
  padding: 7px;
}

.button_ZikiB:hover {
  background-color: var(--_0c8e6d-background);
}

.buttonLogIn_TW30M {
  background-color: var(--_6e6e80-background);
  color: var(--white-color);
}
.buttonLogIn_TW30M:hover {
  background-color: var(--_5a5a67-background);
}
.navFlex_FGI1d {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  height: 100%;
  > div {
    display: flex;
    align-items: center;
  }

  @media (width<=1000px) {
    > div {
      align-items: flex-start;
    }
  }

  .language_KPtu1 {
    display: flex;
    height: 100%;
    align-items: center;
  }
}
.nav_sy0Wm {
  cursor: pointer;
  display: flex;
  gap: 30px;
  height: 100%;
  display: flex;
}

.solucionesWrapper_K755C {
  position: relative;
  display: inline-block;
  height: 100%;
}

.solucionesHover_c519c,
.languageHover_csxIj {
  display: flex;
  gap: 10px;
  align-items: center;
  height: 100%;
  .icon_nkkSv {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    height: 15px;
    width: 15px;
  }
}
.solucionesHover_c519c {
  &:hover + div {
    display: none; 
  }

  @media (min-width: 1000px) {
    &:hover + div {
      display: flex;
    }
  }
}



.buttonContainer_ta06y {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}
.toggleButton_GibYV {
  cursor: pointer;
  background-color: transparent;
  border: none;
  outline: none;
  margin-bottom: 20px;
  margin-right: 10px;
  .icon_nkkSv {
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
  }
}

@media (min-width: 769px) {
  .solucionesHover_c519c:hover + .solutionsContainer_gADaA,
  .solucionesWrapper_K755C:hover .solutionsContainer_gADaA {
    display: grid;
  }
}


.solucionesHover_c519c + .none_rVepl,
.solucionesWrapper_K755C .none_rVepl {
  display: none !important;
}


.solucionesHover_c519c:hover + .solutionsContainer_gADaA,
.solucionesWrapper_K755C:hover .solutionsContainer_gADaA {
  display: grid;
}


@media (max-width: 1000px) {
  .navFlex_FGI1d {
    flex-direction: column-reverse;
    align-items: start;
    margin-bottom: 20px;
    height: unset;
    .nav_sy0Wm {
      flex-direction: column;
    }
  }
  .navbar_TZGTY {
    padding: 0 20px;
  }
  .hamburger_cR5kJ {
    display: block;
  }

  .navLinks_ybPDI {
    position: fixed;
    top: 0;
    left: -100%;
    width: 70%;
    height: 100vh;
    background-color: var(--white-background);
    flex-direction: column;

    align-items: start;
    gap: 15px;
    padding: 50px 30px;
    box-sizing: border-box;
    transition: left 0.3s ease-in-out;
    z-index: 999;
    -webkit-transition: left 0.3s ease-in-out;
    -moz-transition: left 0.3s ease-in-out;
    -ms-transition: left 0.3s ease-in-out;
    -o-transition: left 0.3s ease-in-out;
    -webkit-transition: left 0.3s ease-in-out;
    @media (width<=1000px) {
      padding: 15px 10px;
      /* justify-content: space-between; */
      justify-content: flex-start;
    }
    .btnContainerNavbar_GSJLB {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      button {
        width: 100%;
        height: fit-content;
      }
    }
  }
  .profileStart_z3GVU{
    @media (width<=1000px) {
      justify-content: start;
      flex-direction: column-reverse;
    }
  }
  .ScreenOut_mzMBG{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: transparent;
  }

  .navLinksOpen_UsGxu {
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 9999;
    max-width: 300px;
  }

  .navLinksClosed_DxqX1 {
    left: -100%;
  }

  .button_ZikiB {
    width: 100%;
    max-width: 160px;
    height: 35px;
  }
  .button_ZikiB:hover {
    background-color: var(--_0d8b6d-background);
  }
}
.navFlex_FGI1d {
  .disabledBtn_hIXsi {
    height: 100%;
    color: var(--_6e6e80-background);
    display: flex;
    align-items: center;
    
    @media (width<=1000px) {
      height: fit-content;
    }
  }
}

.profileContainer_d7wJn {
  align-items: center;
  display: flex;
  gap: 10px;
  cursor: pointer;
  .profileText_VoQsY {
    display: flex;
    flex-direction: column;
    text-align: end;
    p {
      font-size: 15px;
      margin: 0;
    }
    span {
      font-size: 10px;
    }
  }
  .initials_a0TCi {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--_16c098-background);
    color: var(--white-color);
    font-size: 20px;
    font-weight: 600;
  }

  .profileImage_qakf7 {
    width: 40px;
    min-width: 40px;
    height: 40px;
    border-radius: 5px;
  }
}

@media (width<=1000px) {
.profileContainer_d7wJn {
    flex-direction: row-reverse;
    span{
      display: flex;
      justify-content: start;
    }
  }

}

@media (max-width: 300px) {
  .profileContainer_d7wJn {
    flex-direction: row-reverse;
  }
  .navLinksOpen_UsGxu {
    padding: 50px 10px;
  }
}

.languagecontainer_oSJ0E {
  position: relative;
  @media (width>=768px) {
    
    &:hover {
      .languageDropdown_TFtzv {
        display: flex;
      }
    }
  }

  .languageDropdown_TFtzv {
    position: absolute;
    display: none;
    top: calc(100%);
    flex-direction: column;
    background: var(--ffffffdb-background);
    backdrop-filter: blur(10px);

    border-radius: 8px;
    box-shadow: 0 2px 10px var(--_0000001a-shadow);
    padding: 4px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    .dropdownItem_xSwtU {
      margin: 0;
      list-style: none;
      display: flex;
      align-items: center;
      gap: 10px;
      color: #333;
      box-sizing: border-box;
      width: 100%;
      padding: 8px;
      border: none;
      background: none;
      text-align: left;
      cursor: pointer;
      font-size: 14px;
      border-radius: 4px;
      transition: background-color 0.2s ease-in-out;
      -webkit-transition: background-color 0.2s ease-in-out;
      -moz-transition: background-color 0.2s ease-in-out;
      -ms-transition: background-color 0.2s ease-in-out;
      -o-transition: background-color 0.2s ease-in-out;

      &:hover {
        background-color: var(--f5-background);
      }
      svg {
        width: 20px;
        height: 20px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        -ms-border-radius: 6px;
        -o-border-radius: 6px;
      }
    }
  }
}

.pWithTooltip_Fbq35 {

  text-decoration: none;
  position: relative;


  &:last-child {
    border: none;
  }

  &::before {
    content: attr(data-tooltip);
    position: absolute;
    top: calc(120% + 4px);
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 10px;
    background: var(--_000000cc-background);
    color: var(--white-color);
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;

  }

  &::after {
    content: "";
    position: absolute;
    top: calc(100% - 2px);
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-bottom-color: var(--_000000cc-background);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
  }

  &:hover::before,
  &:hover::after {
    opacity: 1;
    visibility: visible;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Navbar/Navbar.module.css"],"names":[],"mappings":"AAAA,qGAAqG;;AAErG;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;;EAEb;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;IAChC;MACE,kBAAkB;IACpB;IACA;MACE,gCAAgC;MAChC,yBAAyB;IAC3B;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;;AAIA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ;IACE,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE;MACE,aAAa;IACf;EACF;AACF;;;;AAIA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB;IACE,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;;AAGA;;EAEE,wBAAwB;AAC1B;;;AAGA;;EAEE,aAAa;AACf;;;AAGA;EACE;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb;MACE,sBAAsB;IACxB;EACF;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb,yCAAyC;IACzC,sBAAsB;;IAEtB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,iCAAiC;IACjC,YAAY;IACZ,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;IACpC,yCAAyC;IACzC;MACE,kBAAkB;MAClB,oCAAoC;MACpC,2BAA2B;IAC7B;IACA;MACE,WAAW;MACX,sBAAsB;MACtB,uBAAuB;MACvB;QACE,WAAW;QACX,mBAAmB;MACrB;IACF;EACF;EACA;IACE;MACE,sBAAsB;MACtB,8BAA8B;IAChC;EACF;EACA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,6BAA6B;EAC/B;;EAEA;IACE,OAAO;IACP,MAAM;IACN,aAAa;IACb,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,2CAA2C;EAC7C;AACF;AACA;EACE;IACE,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,mBAAmB;;IAEnB;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,eAAe;EACf;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf;MACE,eAAe;MACf,SAAS;IACX;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;AACA;IACI,2BAA2B;IAC3B;MACE,aAAa;MACb,sBAAsB;IACxB;EACF;;AAEF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB;;IAEE;MACE;QACE,aAAa;MACf;IACF;EACF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,sCAAsC;IACtC,2BAA2B;;IAE3B,kBAAkB;IAClB,8CAA8C;IAC9C,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB;MACE,SAAS;MACT,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,WAAW;MACX,sBAAsB;MACtB,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,gBAAgB;MAChB,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,6CAA6C;MAC7C,qDAAqD;MACrD,kDAAkD;MAClD,iDAAiD;MACjD,gDAAgD;;MAEhD;QACE,sCAAsC;MACxC;MACA;QACE,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,0BAA0B;QAC1B,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;MACvB;IACF;EACF;AACF;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;;;EAGlB;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,uCAAuC;IACvC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;;EAE3B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,6BAA6B;IAC7B,gDAAgD;IAChD,UAAU;IACV,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;;IAEE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\"); */\n\n.navbar {\n  background: var(--ffffffdb-background); \n  backdrop-filter: blur(10px); \n  color: var(--black-color);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  box-sizing: border-box;\n  font-family: \"Inter\", sans-serif;\n  position: fixed; \n  height: 50px;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000; \n\n  .logo {\n    cursor: pointer;\n    height: 30px;\n  }\n  .name{\n    display: flex;\n    align-items: center;\n    font-size: 25px;\n    text-transform: capitalize;\n    font-weight: 400;\n    font-family: \"Inter\", sans-serif;\n    img{\n      margin-right: 10px;\n    }\n    span{\n      font-family: \"Inter\", sans-serif;\n      text-transform: uppercase;\n    }\n  }\n}\n\n.hamburger {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: none; \n}\n\n.hamburger img {\n  width: 25px;\n  height: 25px;\n}\n\n.navLinks {\n  list-style: none;\n  display: flex;\n  gap: 20px;\n  margin: 0;\n  padding: 0;\n  align-items: center;\n  height: 100%;\n}\n.btnContainerNavbar {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n\n\n.navLinks li {\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 400;\n  transition: color 0.3s ease;\n}\n\n.navLinks li:hover {\n  color: var(--ec-color);\n}\n\n.buttonContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.button {\n  background-color: var(--_10a37f-background);\n  color: var(--white-color);\n  width: 120px;\n  font-size: 16px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  border-radius: 7px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  -ms-border-radius: 7px;\n  -o-border-radius: 7px;\n  padding: 7px;\n}\n\n.button:hover {\n  background-color: var(--_0c8e6d-background);\n}\n\n.buttonLogIn {\n  background-color: var(--_6e6e80-background);\n  color: var(--white-color);\n}\n.buttonLogIn:hover {\n  background-color: var(--_5a5a67-background);\n}\n.navFlex {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 30px;\n  height: 100%;\n  > div {\n    display: flex;\n    align-items: center;\n  }\n\n  @media (width<=1000px) {\n    > div {\n      align-items: flex-start;\n    }\n  }\n\n  .language {\n    display: flex;\n    height: 100%;\n    align-items: center;\n  }\n}\n.nav {\n  cursor: pointer;\n  display: flex;\n  gap: 30px;\n  height: 100%;\n  display: flex;\n}\n\n.solucionesWrapper {\n  position: relative;\n  display: inline-block;\n  height: 100%;\n}\n\n.solucionesHover,\n.languageHover {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  height: 100%;\n  .icon {\n    transform: rotate(180deg);\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    height: 15px;\n    width: 15px;\n  }\n}\n.solucionesHover {\n  &:hover + div {\n    display: none; \n  }\n\n  @media (min-width: 1000px) {\n    &:hover + div {\n      display: flex;\n    }\n  }\n}\n\n\n\n.buttonContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n.toggleButton {\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  margin-bottom: 20px;\n  margin-right: 10px;\n  .icon {\n    transform: rotate(-90deg);\n    -webkit-transform: rotate(-90deg);\n    -moz-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    -o-transform: rotate(-90deg);\n  }\n}\n\n@media (min-width: 769px) {\n  .solucionesHover:hover + .solutionsContainer,\n  .solucionesWrapper:hover .solutionsContainer {\n    display: grid;\n  }\n}\n\n\n.solucionesHover + .none,\n.solucionesWrapper .none {\n  display: none !important;\n}\n\n\n.solucionesHover:hover + .solutionsContainer,\n.solucionesWrapper:hover .solutionsContainer {\n  display: grid;\n}\n\n\n@media (max-width: 1000px) {\n  .navFlex {\n    flex-direction: column-reverse;\n    align-items: start;\n    margin-bottom: 20px;\n    height: unset;\n    .nav {\n      flex-direction: column;\n    }\n  }\n  .navbar {\n    padding: 0 20px;\n  }\n  .hamburger {\n    display: block;\n  }\n\n  .navLinks {\n    position: fixed;\n    top: 0;\n    left: -100%;\n    width: 70%;\n    height: 100vh;\n    background-color: var(--white-background);\n    flex-direction: column;\n\n    align-items: start;\n    gap: 15px;\n    padding: 50px 30px;\n    box-sizing: border-box;\n    transition: left 0.3s ease-in-out;\n    z-index: 999;\n    -webkit-transition: left 0.3s ease-in-out;\n    -moz-transition: left 0.3s ease-in-out;\n    -ms-transition: left 0.3s ease-in-out;\n    -o-transition: left 0.3s ease-in-out;\n    -webkit-transition: left 0.3s ease-in-out;\n    @media (width<=1000px) {\n      padding: 15px 10px;\n      /* justify-content: space-between; */\n      justify-content: flex-start;\n    }\n    .btnContainerNavbar {\n      width: 100%;\n      flex-direction: column;\n      align-items: flex-start;\n      button {\n        width: 100%;\n        height: fit-content;\n      }\n    }\n  }\n  .profileStart{\n    @media (width<=1000px) {\n      justify-content: start;\n      flex-direction: column-reverse;\n    }\n  }\n  .ScreenOut{\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    background-color: transparent;\n  }\n\n  .navLinksOpen {\n    left: 0;\n    top: 0;\n    height: 100vh;\n    z-index: 9999;\n    max-width: 300px;\n  }\n\n  .navLinksClosed {\n    left: -100%;\n  }\n\n  .button {\n    width: 100%;\n    max-width: 160px;\n    height: 35px;\n  }\n  .button:hover {\n    background-color: var(--_0d8b6d-background);\n  }\n}\n.navFlex {\n  .disabledBtn {\n    height: 100%;\n    color: var(--_6e6e80-background);\n    display: flex;\n    align-items: center;\n    \n    @media (width<=1000px) {\n      height: fit-content;\n    }\n  }\n}\n\n.profileContainer {\n  align-items: center;\n  display: flex;\n  gap: 10px;\n  cursor: pointer;\n  .profileText {\n    display: flex;\n    flex-direction: column;\n    text-align: end;\n    p {\n      font-size: 15px;\n      margin: 0;\n    }\n    span {\n      font-size: 10px;\n    }\n  }\n  .initials {\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--_16c098-background);\n    color: var(--white-color);\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .profileImage {\n    width: 40px;\n    min-width: 40px;\n    height: 40px;\n    border-radius: 5px;\n  }\n}\n\n@media (width<=1000px) {\n.profileContainer {\n    flex-direction: row-reverse;\n    span{\n      display: flex;\n      justify-content: start;\n    }\n  }\n\n}\n\n@media (max-width: 300px) {\n  .profileContainer {\n    flex-direction: row-reverse;\n  }\n  .navLinksOpen {\n    padding: 50px 10px;\n  }\n}\n\n.languagecontainer {\n  position: relative;\n  @media (width>=768px) {\n    \n    &:hover {\n      .languageDropdown {\n        display: flex;\n      }\n    }\n  }\n\n  .languageDropdown {\n    position: absolute;\n    display: none;\n    top: calc(100%);\n    flex-direction: column;\n    background: var(--ffffffdb-background);\n    backdrop-filter: blur(10px);\n\n    border-radius: 8px;\n    box-shadow: 0 2px 10px var(--_0000001a-shadow);\n    padding: 4px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    .dropdownItem {\n      margin: 0;\n      list-style: none;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      color: #333;\n      box-sizing: border-box;\n      width: 100%;\n      padding: 8px;\n      border: none;\n      background: none;\n      text-align: left;\n      cursor: pointer;\n      font-size: 14px;\n      border-radius: 4px;\n      transition: background-color 0.2s ease-in-out;\n      -webkit-transition: background-color 0.2s ease-in-out;\n      -moz-transition: background-color 0.2s ease-in-out;\n      -ms-transition: background-color 0.2s ease-in-out;\n      -o-transition: background-color 0.2s ease-in-out;\n\n      &:hover {\n        background-color: var(--f5-background);\n      }\n      svg {\n        width: 20px;\n        height: 20px;\n        border-radius: 6px;\n        -webkit-border-radius: 6px;\n        -moz-border-radius: 6px;\n        -ms-border-radius: 6px;\n        -o-border-radius: 6px;\n      }\n    }\n  }\n}\n\n.pWithTooltip {\n\n  text-decoration: none;\n  position: relative;\n\n\n  &:last-child {\n    border: none;\n  }\n\n  &::before {\n    content: attr(data-tooltip);\n    position: absolute;\n    top: calc(120% + 4px);\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 5px 10px;\n    background: var(--_000000cc-background);\n    color: var(--white-color);\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: nowrap;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n\n  }\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: calc(100% - 2px);\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-bottom-color: var(--_000000cc-background);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n  }\n\n  &:hover::before,\n  &:hover::after {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `navbar_TZGTY`,
	"logo": `logo_NHVZT`,
	"name": `name_IKJJ5`,
	"hamburger": `hamburger_cR5kJ`,
	"navLinks": `navLinks_ybPDI`,
	"btnContainerNavbar": `btnContainerNavbar_GSJLB`,
	"buttonContainer": `buttonContainer_ta06y`,
	"button": `button_ZikiB`,
	"buttonLogIn": `buttonLogIn_TW30M`,
	"navFlex": `navFlex_FGI1d`,
	"language": `language_KPtu1`,
	"nav": `nav_sy0Wm`,
	"solucionesWrapper": `solucionesWrapper_K755C`,
	"solucionesHover": `solucionesHover_c519c`,
	"languageHover": `languageHover_csxIj`,
	"icon": `icon_nkkSv`,
	"toggleButton": `toggleButton_GibYV`,
	"solutionsContainer": `solutionsContainer_gADaA`,
	"none": `none_rVepl`,
	"profileStart": `profileStart_z3GVU`,
	"ScreenOut": `ScreenOut_mzMBG`,
	"navLinksOpen": `navLinksOpen_UsGxu`,
	"navLinksClosed": `navLinksClosed_DxqX1`,
	"disabledBtn": `disabledBtn_hIXsi`,
	"profileContainer": `profileContainer_d7wJn`,
	"profileText": `profileText_VoQsY`,
	"initials": `initials_a0TCi`,
	"profileImage": `profileImage_qakf7`,
	"languagecontainer": `languagecontainer_oSJ0E`,
	"languageDropdown": `languageDropdown_TFtzv`,
	"dropdownItem": `dropdownItem_xSwtU`,
	"pWithTooltip": `pWithTooltip_Fbq35`
};
export default ___CSS_LOADER_EXPORT___;
